import React, { useState, useRef } from 'react'
import Card from './Card'
import Map from './charts/Map'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Bar from './charts/Bar'

const useStyles = makeStyles((theme) => ({
	progress: {
		marginTop: -50,
		color: theme.palette.grey[600]
	},
	loader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400
	},
	title: {
		fontWeight: 600,
		textAlign: 'center',
		fontSize: 23,
		margin: '3em auto 1em'
	},
	resume: {
		margin: '0 auto 3em',
		textAlign: 'center'
	},
	title2: {
		fontWeight: 600,
		textAlign: 'center',
		marginBottom: 20,
		fontSize: 18
	},
	title3: {
		fontWeight: 300,
		textAlign: 'center',
		marginBottom: 30,
		fontSize: 14
	},
	card: {
		display: 'flex',
		justifyContent: 'center',
		height: '100%',
		alignItems: 'center'
	}
}))

const SentenciasAlimentos = ({ data, departmentsData, provincesData}) => {
	const listContainer = useRef(null)
	const classes = useStyles()
	const [ selected, setSelected ] = useState([])
	const [ selectedTitle, setSelectedTitle ] = useState('')
	const [ selectedSubTitle, setSelectedSubTitle] = useState('')
	const [ level, setLevel ] = useState('province')

	const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

	const showList = ({ id, total, value }) => {
		setLevel('province')
		let elements = provincesData.filter((f) => f.id === id)
		let department = departmentsData.find((f) => f.id === id)
		if (elements.length > 0) {
			setSelectedTitle(`Presupuesto ejecutado en las provincias de la región ${department.name}`)
			setSelectedSubTitle(`${value}% de municipios con 0% de ejecución. Total municipios: ${total}`)
			setSelected(elements.sort((a,b) => Number(a.value) - Number(b.value)))
			scrollToRef(listContainer)
		}
	}

	const showMunicipios = ({ province, alcalde }) => {
		setLevel('municipe')
		let elements = data.filter((f) => f.province === province && f.name.search('Prov.') !== 0)
		setSelectedTitle(`Presupuesto ejecutado en los municipios de la provincia ${elements[0].province}`)
		setSelectedSubTitle(`Alcalde provincia: ${alcalde}`)
		setSelected(elements.sort((a,b) => Number(a.value) - Number(b.value)))
	}
	return (
		<div>
			{data && data.length > 0 ? (
				<Grid container spacing={8} justify="center">
					<Grid item md={4} xs={12}>
						{departmentsData &&
						departmentsData.length > 0 && (
							<div style={{ margin: '1em auto' }}>
								<Map data={departmentsData} showList={showList} />
							</div>
						)}
					</Grid>
					<Grid item md={8} xs={12} ref={listContainer}>
						<h2 className={classes.title2}>{selectedTitle}</h2>
						<div className={classes.title3}>{selectedSubTitle}</div>
						{selected && selected.length > 0 ? (
							<div style={{ height: '100%' }}>
								<Bar data={selected} showMunicipios={showMunicipios} level={level} />
							</div>
						) : (
							<div className={classes.card}>
								<Card />
							</div>
						)}
					</Grid>
				</Grid>
			) : (
				<div className={classes.loader}>
					<CircularProgress className={classes.progress} />
				</div>
			)}
		</div>
	)
}

export default SentenciasAlimentos
